import React, { memo } from "react";
import Select from "react-select";
import useFilterDataSource from "../hooks/useFilterDataSource";

/* ---- react-select inline styles (matches V2CmnFilters) ---- */
const v2SelectStyles = {
  control: (base) => ({
    ...base,
    minHeight: 40,
    height: 40,
    background: "transparent",
    border: "none",
    boxShadow: "none",
    cursor: "pointer",
    borderRadius: 8,
  }),
  valueContainer: (base) => ({
    ...base,
    padding: "0 12px",
    height: 40,
    display: "flex",
    alignItems: "center",
  }),
  placeholder: (base) => ({
    ...base,
    color: "var(--v2-text-muted, #8e939e)",
    fontSize: 13,
    fontWeight: 400,
    margin: 0,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  }),
  singleValue: (base) => ({
    ...base,
    color: "var(--v2-text-primary, #30343c)",
    fontSize: 13,
    fontWeight: 400,
    margin: 0,
  }),
  input: (base) => ({
    ...base,
    fontSize: 13,
    color: "var(--v2-text-primary, #30343c)",
    margin: 0,
    padding: 0,
  }),
  indicatorSeparator: () => ({ display: "none" }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: "0 8px",
    color: "var(--v2-text-muted, #8e939e)",
  }),
  clearIndicator: (base) => ({
    ...base,
    padding: "0 4px",
    color: "var(--v2-text-muted, #8e939e)",
  }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
};

const V2FilterSelect = ({
  schemaItem,
  value,
  onChange,
  userInfoData,
  filters,
  setFilters,
  isDisabled,
}) => {
  const { options } = useFilterDataSource(
    schemaItem.dataSource ? schemaItem : { ...schemaItem, dataSource: null },
    userInfoData,
    filters,
    setFilters
  );

  const resolvedOptions =
    schemaItem.staticOptions || (options.length > 0 ? options : []);

  const hasValue = value && (value.value !== undefined ? !!value.value : !!value);

  return (
    <div
      className={`v2-fltr__item${schemaItem.span === 2 ? " v2-fltr__item--span2" : ""}${
        hasValue ? " v2-fltr__item--active" : ""
      }`}
    >
      <Select
        value={value || null}
        onChange={onChange}
        options={resolvedOptions}
        placeholder={schemaItem.placeholder || "Select..."}
        isClearable={schemaItem.isClearable !== false}
        isSearchable={schemaItem.isSearchable !== false}
        isDisabled={isDisabled || schemaItem.isDisabled}
        menuPortalTarget={document.body}
        styles={v2SelectStyles}
      />
    </div>
  );
};

export default memo(V2FilterSelect);
